import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { SettingsModel } from "@insite/client-framework/Services/SettingsService";

declare let Stripe: ((publishableKey: string) => any) | null;

interface StripeRadarSessionResponse {
    radarSession?: {
        id: string;
    };
    error?: {
        message: string;
    };
}

type HandlerType = Handler<{}, { settings: SettingsModel }>;

export const LookUpData: HandlerType = props => {
    const state = props.getState();

    if (IS_SERVER_SIDE) {
        return false;
    }

    props.settings = state.context.settings;
};

export const LoadStripeScript: HandlerType = async props => {
    const { stripePublishableKey } = props.settings.settingsCollection.websiteSettings;

    if (!stripePublishableKey) {
        return false;
    }

    await new Promise<void>(resolve => {
        if (typeof Stripe !== "undefined" && Stripe) {
            resolve();
            return;
        }

        let script = document.getElementById("stripeRadarScript");
        if (script) {
            script.addEventListener("load", () => resolve(), { once: true });
            return;
        }

        script = document.createElement("script");
        script.setAttribute("id", "stripeRadarScript");
        script.setAttribute("src", "https://js.stripe.com/v3");
        script.setAttribute("async", "");
        script.addEventListener("load", () => resolve(), { once: true });
        document.head.appendChild(script);
    });
};

export const CreateStripeRadarSession: HandlerType = async props => {
    const { settings, dispatch } = props;
    const { stripePublishableKey, enabledSpreedlyStripeRadar } = settings.settingsCollection.websiteSettings;

    if (!enabledSpreedlyStripeRadar) {
        return;
    }

    if (typeof Stripe === "undefined" || !Stripe) {
        dispatch({ type: "Context/SetStripeRadarSessionId", stripeRadarSessionId: null });
        return;
    }

    try {
        const stripe = Stripe(stripePublishableKey);
        const response: StripeRadarSessionResponse = await stripe.createRadarSession();
        const sessionId = response?.radarSession?.id ?? null;
        dispatch({ type: "Context/SetStripeRadarSessionId", stripeRadarSessionId: sessionId });
    } catch {
        dispatch({ type: "Context/SetStripeRadarSessionId", stripeRadarSessionId: null });
    }
};

export const chain = [LookUpData, LoadStripeScript, CreateStripeRadarSession];

export const setStripeScript = createHandlerChainRunnerOptionalParameter(chain, {}, "SetStripeScript");
